import React from 'react';
import AlertForm from '../../components/AlertForm';
import LoginButton from '../../components/LoginButton';
import { useAuth0 } from '@auth0/auth0-react';

export default function CreateAlert() {

    const { isAuthenticated } = useAuth0();
	
	if (!isAuthenticated) {
		return (
			<div style={{ padding: '2rem', textAlign: 'center' }}>
				<header className="App-header">
					<h1>Train Price Alerts</h1>
					<p>Please log in to create a price alert</p>
				</header>
				<div style={{ marginTop: '2rem' }}>
					<LoginButton />
				</div>
			</div>
		);
	}
	
	return (
		<div style={{ padding: '2rem' }}>
            <header className="App-header">
                <h1>Train Price Alerts</h1>
                <p>Create a new price alert for your train trip</p>
            </header>
			<AlertForm />
		</div>
	);
}

